import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const homeFor = (role) => ({ admin: "/admin", dipendente: "/admin", vet: "/veterinario", cliente: "/cliente" }[role] || "/");

export const FileUpload = ({ url, fields = {}, accept = "*", label = "Carica file", onDone, testid = "file-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const send = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(fields).forEach(([k, v]) => fd.append(k, v ?? ""));
    setBusy(true);
    try { const { data } = await api.post(url, fd); toast.success("File caricato"); onDone?.(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={(e) => send(e.target.files?.[0])} data-testid={`${testid}-input`} />
      <Button type="button" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testid}-button`} className="rounded-full">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Upload className="h-4 w-4 mr-1" />{label}</>}
      </Button>
    </>
  );
};

export async function downloadAuth(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const Section = ({ title, children, right }) => (
  <div className="rounded-2xl border border-[#E2DDD5] bg-white p-6">
    <div className="flex items-center justify-between mb-4"><p className="font-display text-2xl font-semibold text-[#0D3B52]">{title}</p>{right}</div>
    {children}
  </div>
);

export const STATO_PERMESSO = {
  in_attesa: "bg-amber-50 text-amber-800 border-amber-200",
  approvato: "bg-emerald-50 text-emerald-800 border-emerald-200",
  rifiutato: "bg-rose-50 text-rose-700 border-rose-200",
};
